import { Link } from "react-router-dom";
import { FaClock, FaIdCard, FaSignOutAlt, FaBusinessTime, FaExchangeAlt, FaUserCheck } from "react-icons/fa";

const Time = () => {
  const links = [
    { name: "Attendance", path: "attendance/", icon: <FaUserCheck /> },
    { name: "Check Attendance", path: "check-attendance/", icon: <FaClock /> },
    { name: "Upload Attendance", path: "attendance-upload/", icon: <FaUserCheck /> },
    { name: "Swipe Request", path: "swipe/", icon: <FaIdCard /> },
    { name: "Short Time Off", path: "short-time-off/", icon: <FaSignOutAlt /> },
    { name: "Shift Change", path: "shift-change/", icon: <FaExchangeAlt /> },
    { name: "Clock-In Attendance", path: "mob-attendance/", icon: <FaUserCheck /> }
  ];

  return (
  <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 w-full p-6 bg-white shadow-lg rounded-lg">
    {links.map((link, index) => (
      <Link to={link.path} className="text-gray-700 hover:text-blue-600 font-medium">
        <li key={index} className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg hover:bg-blue-100 transition">
          <span className="text-blue-500 text-xl">{link.icon}</span>
          {link.name}
        </li>
      </Link>
    ))}
  </ul>

  );
};

export default Time;
